import { render, staticRenderFns } from "./Kopfzeile.vue?vue&type=template&id=ca1956e8&scoped=true"
import script from "./Kopfzeile.vue?vue&type=script&lang=js"
export * from "./Kopfzeile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1956e8",
  null
  
)

export default component.exports